const autoNgTemplateLoaderTemplate1 = require('./applicationsPortsDatatable.html');

angular.module('portainer.kubernetes').component('kubernetesApplicationsPortsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesApplicationsPortsDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    refreshCallback: '<',
  },
});
